import { render, staticRenderFns } from "./ReviewDialog.vue?vue&type=template&id=604a8792&scoped=true&"
import script from "./ReviewDialog.vue?vue&type=script&lang=js&"
export * from "./ReviewDialog.vue?vue&type=script&lang=js&"
import style0 from "./ReviewDialog.vue?vue&type=style&index=0&id=604a8792&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604a8792",
  null
  
)

export default component.exports